<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <WalletCard :class="b()" title="Последние операции" tab="deposit-withdrawal">
    <div v-if="displayedHistory.length" :class="b('table')">
      <div :class="b('rows')">
        <WalletHistoryRow
          :class="b('row')"
          v-for="row in displayedHistory"
          :key="row.id"
          :row="row"
        />
      </div>
    </div>

    <div v-else :class="b('empty')">
      <span :class="b('empty-icon')">↓</span>
      <h5 :class="b('empty-title')">{{ $t("Пока нет операций") }}</h5>
      <p :class="b('empty-text')">
        {{ $t("Пополнения и выводы появятся здесь после первой операции") }}
      </p>
      <button :class="b('empty-cta')" @click="$emit('deposit')">
        {{ $t("Пополнить") }}
      </button>
    </div>
  </WalletCard>
</template>
